import { ComponentPropsWithRef } from 'react';
import { cn } from '@/shared/lib/cn';
import './field-message.scss';

type Props = ComponentPropsWithRef<'div'>;
export const FieldMessageWrapper = ({ className, ...props }: Props) => {
    return <div className={cn('field-message__wrapper', className)} {...props} />;
};
